import React, { useEffect, useState } from 'react';
import { Pagination } from '../Pagination/Pagination';
import { PageRange } from 'neon-design-system';
import { NoRequestsToDisplayView } from '../NoRequestsToDisplayView/NoRequestsToDisplayView';
import { usePaginationRequestInfo } from '../../providers/PaginationRequestProvider';
import { FilterKey } from '../../providers/FiltersProvider';

interface GridComponentProps<T> {
  rowData: T[];
  paginationPageSize: number;
  currentPage: number;
}

interface Props<T> {
  rowData: T[];
  hidePagination?: boolean;
  GridComponent: React.FC<GridComponentProps<T>>;
  noRequestsToDisplayTitle?: string;
  noRequestsToDisplayDescription?: string;
  activeFilterName: FilterKey;
}
const defaultPageRange = { label: '15', value: 15 };
export const PaginationGridWrapper = <T,>(props: Props<T>) => {
  const { rowData, hidePagination, GridComponent, noRequestsToDisplayTitle, noRequestsToDisplayDescription, activeFilterName } = props;
  const { setPaginationInfo, paginationInfo } = usePaginationRequestInfo(activeFilterName);
  const pageRange = paginationInfo?.pageSize ? { label: paginationInfo.pageSize.toString(), value: paginationInfo.pageSize } : defaultPageRange;
  const [selectedRange, setSelectedRange] = useState<PageRange>(pageRange);
  const onPageChanged = (delta: number) => {
    const newCurrentPage = paginationInfo?.pageNumber! + delta;
    if (newCurrentPage < 1) return;

    setPaginationInfo({
      ...paginationInfo,
      pageNumber: newCurrentPage,
      pageSize: selectedRange.value
    });
  };

  useEffect(() => {
    if (selectedRange.value !== paginationInfo?.pageSize)
      setPaginationInfo({
        ...paginationInfo,
        pageNumber: 1,
        pageSize: selectedRange.value
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRange.value]);

  const currentPage = paginationInfo?.pageNumber || 1;

  if (!rowData.length)
    return <NoRequestsToDisplayView noRequestsToDisplayTitle={noRequestsToDisplayTitle} noRequestsToDisplayDescription={noRequestsToDisplayDescription} />;
  return (
    <>
      <GridComponent rowData={rowData} paginationPageSize={selectedRange.value} currentPage={currentPage} />
      {hidePagination || (
        <Pagination
          id="requestsGridPagination"
          totalRecords={paginationInfo?.totalRecords || 0}
          selectedRange={selectedRange}
          currentPage={currentPage}
          setSelectedRange={setSelectedRange}
          onPageChanged={onPageChanged}
        />
      )}
    </>
  );
};

export default PaginationGridWrapper;
